import { Alert, CircularProgress, Stack } from '@mui/material';
import { Suspense, lazy, type ComponentType } from 'react';
import { useIntl } from 'react-intl';

import RemoteBoundary from '../../components/AppLayout/RemoteBoundary';
import { useUserData } from '../../redux/selectors';

interface NotificationPageProps {
  locale?: string;
}

const NotificationPage = lazy<ComponentType<NotificationPageProps>>(
  () => import('notificationMicrofrontend/NotificationPage')
);

const Notifications = (): React.ReactElement => {
  const intl = useIntl();
  const user = useUserData();

  return (
    <RemoteBoundary
      name='NotificationPage'
      microfrontend='notification-mf'
      fallback={
        <Alert severity='warning'>{intl.formatMessage({ id: 'notificationsUnavailable' })}</Alert>
      }
    >
      <Suspense
        fallback={
          <Stack
            alignItems='center'
            padding={4}
          >
            <CircularProgress />
          </Stack>
        }
      >
        <NotificationPage locale={user.locale ?? 'en'} />
      </Suspense>
    </RemoteBoundary>
  );
};

export default Notifications;
